import { BaseModel } from './baseModel';
import { Workflow } from './workflow';

export class EventType extends BaseModel {
  constructor(
    public name: string,
    public workflow: number | Workflow
  ) { super(); }
}
